import React, { useEffect, useState } from "react";

import mainLogoImg from "../../../assets/images/header-logos/default.svg";
import galleryLogoImg from "../../../assets/images/header-logos/gallery.svg";
import matchLogoImg from "../../../assets/images/header-logos/match.svg";
import proofLogoImg from "../../../assets/images/header-logos/proof.svg";

const logos = {
  default: mainLogoImg,
  gallery: galleryLogoImg,
  match: matchLogoImg,
  proof: proofLogoImg,
};

const Logo = ({logo}) => {
  return <img src={logos[logo]} className={`header__logo-icon`} />;
};

export default Logo;
